import { FaYoutube,FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
    var year = new Date().getFullYear();
    return ( 
        <footer className="page-footer grey-background">
            <div className="custom-container">
                <div className="footer-cont mb-5">
                    <div>
                        <h5 className="is-size-5 mb-4 has-text-weight-semibold">Quick Links</h5>
                        <ul className="footer-list">
                            <li><Link to="/"  className="grey-text text-lighten-3">Home Page</Link></li>
                            <li><Link to="/portal" className="grey-text text-lighten-3">Students' Portal</Link></li>
                            <li><Link to="online-application" className="grey-text text-lighten-3">Online Applicataion</Link></li>    
                            <li><Link to="/admin" className="grey-text text-lighten-3">Admin</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h5  className="is-size-5 mb-4 has-text-weight-semibold">Contact Us</h5>
                        <ul className="footer-list">
                            <li><a href="tel:0787 625 134"  className="grey-text text-lighten-3" target="_blank" rel="noreferrer">0787 625 134</a></li>
                            <li><a href="tel:0719 216 324" className="grey-text text-lighten-3" target="_blank" rel="noreferrer">0719 216 324</a></li>
                            <li><a href="mailto:lifelongcollege@gmail.com" className="grey-text text-lighten-3 hide-on-tiny" target="_blank" rel="noreferrer">lifelongcollege@gmail.com</a></li>
                            <li><a href="mailto:info@lifelongpolytechnic.co.zw" className="grey-text text-lighten-3 hide-on-tiny" target="_blank" rel="noreferrer">info@lifelongpolytechnic.co.zw</a></li>
                        </ul>
                    </div>
                    <div>
                        <h5  className="is-size-5 mb-4 has-text-weight-semibold">Divisions</h5>
                        <ul className="footer-list">
                            <li><Link to="/division/aas"  className="grey-text text-lighten-3">Applied Arts and Science</Link></li>
                            <li><Link to="/division/ccd" className="grey-text text-lighten-3">Civil and Construction</Link></li>
                            <li><Link to="/division/engineering" className="grey-text text-lighten-3">Engineering</Link></li>
                            <li><Link to="/division/commerce" className="grey-text text-lighten-3">Commerce</Link></li>
                        </ul>
                    </div>
                    <div>
                        <h5 className="is-size-5 mb-4 has-text-weight-semibold">Banking Details</h5>
                        <ul className="footer-list">
                            <li>Account Name: <b>Vadzanayi Mushayi</b></li>
                            <li>Bank: <b>BancABC</b></li>
                            <li>Account Number: <b>4867621017961449</b></li>
                        </ul>
                    </div>   
                </div>
            </div>
            <div className="footer-copyright">
                <div className="container">
                    <small className="grey-text text-darken-1 ml-4 has-text-weight-bold">© {year} Life Long Polytechnic | Site By <a className="grey-text text-darken-1 has-text-weight-bold" href="https://scalacoms.co.zw/" target="_blank" rel="noreferrer">Scalacoms</a></small>
                    <div className="right nav-icons mr-3 mt-2 hide-on-tiny">
                        <a href="https://www.facebook.com/Life-Long-Polytechnic-105016771805634/" target="_blank" rel="noreferrer">
                            <FaFacebook fontSize="1.1rem" className="mx-2 grey-text text-darken-1"/>
                        </a>
                        <a href="https://www.instagram.com/invites/contact/?i=155z9zr1uupd&utm_content=mup8gor" target="_blank" rel="noreferrer">
                            <FaInstagram fontSize="1.1rem" className="mx-2 grey-text text-darken-1"/>
                        </a>
                        <a href="https://www.youtube.com/channel/UC-sJHuTUquADtt3VAfW-Q3A" target="_blank" rel="noreferrer">
                            <FaYoutube fontSize="1.1rem" className="mx-2 grey-text text-darken-1"/>
                        </a>
                        <a href="#!">
                            <FaTwitter fontSize="1.1rem" className="mx-2 grey-text text-darken-1"/>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
     );
}
 
export default Footer;